// EVM 链元数据：后端 config.chains 只给合约/授权地址，不给 chainId 和 RPC，
// 而 approve 前必须把钱包切到对应网络，否则会在错误的链上对另一条链的合约发交易。
// 这里按后端的 chains[].code 补齐 wallet_switchEthereumChain / wallet_addEthereumChain 所需参数。

export const EVM_CHAIN_META = {
  erc: {
    chainIdHex: "0x1",
    chainIdNum: 1,
    chainName: "Ethereum Mainnet",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: ["https://ethereum-rpc.publicnode.com"],
    blockExplorerUrls: ["https://etherscan.io"],
  },
  bsc: {
    chainIdHex: "0x38",
    chainIdNum: 56,
    chainName: "BNB Smart Chain",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: ["https://bsc-dataseed.binance.org"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
};

export function getEvmChainMeta(code) {
  return EVM_CHAIN_META[String(code || "").toLowerCase()] || null;
}
